import { EMPTY_LIST } from '../../../constants/common'
import { FORMIK_EMPTY_VALUE } from '../../../constants/validation'

export const CHAT_FORM_FIELD_NAME_TITLE = 'title'

export const CHAT_FORM_FIELD_NAME_PARTICIPANTS = 'users'

export const CHAT_FORM_FIELD_NAME_MESSAGE = 'text'

export const CHAT_FORM_FIELD_NAME_LABELS = 'labels'

export const CHAT_FORM_FIELD_NAME_FILES = 'files'

export const CHAT_FORM_FIELD_NAME_STORAGE_FILES = 'storageFiles'

export const CHAT_FORM_INITIAL_VALUES = {
  [CHAT_FORM_FIELD_NAME_FILES]: EMPTY_LIST,
  [CHAT_FORM_FIELD_NAME_LABELS]: EMPTY_LIST,
  [CHAT_FORM_FIELD_NAME_MESSAGE]: FORMIK_EMPTY_VALUE,
  [CHAT_FORM_FIELD_NAME_PARTICIPANTS]: EMPTY_LIST,
  [CHAT_FORM_FIELD_NAME_STORAGE_FILES]: EMPTY_LIST,
  [CHAT_FORM_FIELD_NAME_TITLE]: FORMIK_EMPTY_VALUE,
}

export const CHAT_FORM_TITLE_FIELD_MAX_LENGTH = 255
